module.exports = __webpack_public_path__ + "img/LevelNext_SpringShowcase-onblack.b049dc6c.png";